import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import noop from 'lodash/noop';
import PriceRangeFilter from 'components/Filters/Search/PriceFilter/PriceRangeFilter';
import { getMinAvailableCashPrice, getMaxAvailableCashPrice } from 'store/search/searchSelectors';
import formatNumber from 'lib/formatters/formatNumber';
import { getQueryMaxPrice, getQueryMinPrice } from 'store/search/searchSelectors/querySelectors';

const STEP_INCREMENT = 10;
const UPPER_PRICE_LIMIT = 800;
const formatPrice = (price) => `$${formatNumber({ number: price })}`;

const CashPriceRangeFilter = ({ onChange, updatePriceRangeLabels }) => {
  const minAvailablePrice = useSelector(getMinAvailableCashPrice);
  const maxAvailablePrice = useSelector(getMaxAvailableCashPrice);
  const minPrice = useSelector(getQueryMinPrice);
  const maxPrice = useSelector(getQueryMaxPrice);

  return (
    <PriceRangeFilter
      currency="AUD"
      minAvailablePrice={minAvailablePrice}
      maxAvailablePrice={maxAvailablePrice}
      minPrice={minPrice}
      maxPrice={maxPrice}
      minPriceLabelValue={minPrice}
      maxPriceLabelValue={maxPrice}
      onChange={onChange}
      updatePriceRangeLabels={updatePriceRangeLabels}
      stepIncrement={STEP_INCREMENT}
      upperPriceLimit={UPPER_PRICE_LIMIT}
      formatPrice={formatPrice}
    />
  );
};

CashPriceRangeFilter.propTypes = {
  onChange: PropTypes.func,
  updatePriceRangeLabels: PropTypes.func,
};

CashPriceRangeFilter.defaultProps = {
  onChange: noop,
  updatePriceRangeLabels: noop,
};

export default CashPriceRangeFilter;
